import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface AdminGuardProps {
  children: React.ReactNode;
}

export function AdminGuard({ children }: AdminGuardProps) {
  const navigate = useNavigate();
  const { authUser, isAdmin, isSupportUser, loading } = useAuth();

  useEffect(() => {
    if (!loading) {
      if (!authUser) {
        navigate('/admin', { replace: true });
      } else if (isSupportUser) {
        navigate('/support', { replace: true });
      } else if (!isAdmin) {
        navigate('/dashboard', { replace: true });
      }
    }
  }, [authUser, isAdmin, isSupportUser, loading, navigate]);

  if (loading || !authUser || !isAdmin || isSupportUser) {
    return null;
  }

  return <>{children}</>;
}
